// ----------------------------------------------------------------------
export function dialog(theme) {
    return {
        MuiDialog: {
            styleOverrides: {
                paper: ({ ownerState }) => (Object.assign({ boxShadow: theme.customShadows.dialog, [theme.breakpoints.down("md")]: {
                        width: "100%",
                        maxHeight: "calc(100svh - 32px)",
                    }, borderRadius: 24 }, (!ownerState.fullScreen && {
                    margin: theme.spacing(2),
                }))),
                paperFullScreen: {
                    borderRadius: 0,
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(3),
                    [theme.breakpoints.down("sm")]: {
                        padding: theme.spacing(1, 2),
                    },
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(0, 3),
                    [theme.breakpoints.down("sm")]: {
                        padding: theme.spacing(0, 2),
                    },
                },
                dividers: {
                    borderTop: 0,
                    borderBottomStyle: "dashed",
                    paddingBottom: theme.spacing(3),
                    [theme.breakpoints.down("sm")]: {
                        paddingBottom: theme.spacing(1),
                    },
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(3),
                    [theme.breakpoints.down("sm")]: {
                        padding: theme.spacing(1),
                    },
                    [theme.breakpoints.down("md")]: {
                        "& > *": {
                            flex: "1 1 auto",
                        },
                    },
                    "& > :not(:first-of-type)": {
                        marginLeft: theme.spacing(1, 2),
                    },
                },
            },
        },
    };
}
